import { createFileRoute } from '@tanstack/react-router';
import { getQuotationsOptions } from '../../../../features/customer/quotations/queryOptions';
import { QuotationsTable } from '../../../../features/customer/quotations/table';
import { validateSearch } from '../../../../utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/quotations',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getQuotationsOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();
  return (
    <div className="col-span-full flex items-center justify-between">
      <QuotationsTable quotations={data} />
    </div>
  );
}
